import classNames from 'classnames';
import { ClassName } from 'types/ClassName';
import { IChildrenProps } from 'types/ChildrenProps';
import { IElementProps } from 'types/ElementProps';
import './DashboardRibbon.scss';
import useIsInIframe from 'hooks/store/useIsInIframe';
import { DashboardTheme } from 'containers/dashboard/types/types';

export interface IDashboardRibbonProps extends IChildrenProps {
  onClick?: IElementProps<HTMLDivElement>['onClick'];
  style?: IElementProps<HTMLDivElement>['style'];
  theme: DashboardTheme;
  className?: ClassName;
}

function DashboardRibbon({ onClick, theme, className, ...rest }: IDashboardRibbonProps) {
  const isInIframe = useIsInIframe();

  const classes = classNames(
    'dashboard-ribbon',
    theme,
    { clickable: onClick !== undefined },
    { 'is-in-iframe': isInIframe },
    className
  );

  return <div className={classes} onClick={onClick} {...rest} />;
}

export default DashboardRibbon;
